<div id="pagination" class="container-fluid">
  <div class="row pad-l pull-right">
    <div>
      <button [disabled]="pageNumber == 0" (click)="prev()">
        <i class="fas fa-angle-left"></i>
      </button>
    </div>
    <div class="h-align pagination">
      <span class="bold">&nbsp;<span *ngIf="pageNumber < 10">0</span>{{pageNumber + 1 }}</span>
      <span class="bold">&nbsp;-&nbsp;</span>
      <span class="bold"><span *ngIf="totalPages < 10">0</span>{{totalPages}}</span>
      <span>&nbsp;/&nbsp;</span>
      <span>{{totalItems}}</span>
    </div>
    <div>
      <button [disabled]="pageNumber == totalPages - 1" (click)="next()">
        <i class="fas fa-angle-right"></i>
      </button>
    </div>
  </div>
</div>